module.exports = __webpack_public_path__ + "media/word-cloud.a3fe42c1.webm";